'use strict';

const ID = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,179}$/; // Opening request IDs survive a same-tab reload. No access/session token is stored.
// A browser that cannot persist IDs keeps the read-only catalogue available.

function createOpeningSession(host, scopeKey) {
  try {
    if (!host || !ID.test(scopeKey) || !host.crypto || typeof host.crypto.getRandomValues !== 'function') return null;
    const raw = host.sessionStorage,
          prefix = 'op-card-open-v1:' + scopeKey + ':';
    if (!raw || typeof raw.getItem !== 'function' || typeof raw.setItem !== 'function' || typeof raw.removeItem !== 'function') return null;

    const requestId = () => {
      const bytes = new Uint8Array(16);
      host.crypto.getRandomValues(bytes);
      return 'opopen-' + Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('');
    };

    const probe = prefix + 'storage-probe:' + requestId();
    raw.setItem(probe, '1');
    const persisted = raw.getItem(probe) === '1';
    raw.removeItem(probe);
    if (!persisted) return null;

    const key = value => {
      if (typeof value !== 'string' || !value.startsWith(prefix) || value.length > 500) throw Error('OPENING_STORAGE_SCOPE');
      return value;
    };

    const quoteKey = 'op-card-quote-intents-v1:' + scopeKey;
    return Object.freeze({
      storage: Object.freeze({
        getItem: k => k === quoteKey ? null : raw.getItem(key(k)),
        setItem: (k, v) => raw.setItem(key(k), String(v)),
        removeItem: k => raw.removeItem(key(k))
      }),
      makeRequestId: requestId
    });
  } catch (_) {
    return null;
  }
}

module.exports = {
  createOpeningSession
};
